import { render } from "./Schema.vue?vue&type=template&id=397573bc"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QLinearProgress});
